import 'css-chunksrc/client/common/dateTimeInput/styles.scss';export default {
  "dateTimeInput": "_dateTimeInput_1fhwf_1",
  "main": "_main_1fhwf_7",
  "noIcon": "_noIcon_1fhwf_20",
  "input": "_input_1fhwf_25",
  "readOnly": "_readOnly_1fhwf_30",
  "icon": "_icon_1fhwf_52",
  "calendar": "_calendar_1fhwf_60",
  "calendarBottom": "_calendarBottom_1fhwf_71",
  "calendarTop": "_calendarTop_1fhwf_75",
  "calendarRight": "_calendarRight_1fhwf_80",
  "calendarLeft": "_calendarLeft_1fhwf_85",
  "opened": "_opened_1fhwf_90",
  "invalid": "_invalid_1fhwf_95"
};